export interface SliceStatusResult {
    type: string;
    code: string;
    description: string;
}

export class SliceStatusResultExtentions {
    public static succeeded(): SliceStatusResult {
        return { type: 'success', code: '', description: '' };
    }

    public static failed(code: string, description: string): SliceStatusResult {
        return { type: 'error', code: code, description: description };
    }

    public static failedPayment(): SliceStatusResult {
        return { type: 'failed-payment', code: '', description: '' };
    }
}